class restoreTicketTemplate {
    constructor($state, $http, alert) {
        this.key = 'restore-pdf-ticket';
        this.title = 'Restore';
        this.level = 'archived-highlight';
        this.icon = 'undo';
        this.order = 15;
        this.state = $state;
        this.http = $http;
        this.alert = alert;
    }

    action(model, vm) {
        this.http.put(`tickets/templates/${vm.model.id}/restore`)
            .then(() => {
                this.state.go('app.tickets.templates.edit', {id: vm.model.id}, {reload: true});
            }, err => this.alert.handle(err));
    }

}

angular
    .module('festzelt-os.modules.tickets')
    .factory('restoreTicketTemplate', [
        '$state',
        '$http',
        'Alert',
        ($state, $http, Alert) => new restoreTicketTemplate($state, $http, Alert)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/workflows/details/restore-ticket-template.js